import { ProviderContext } from 'notistack';

let globalSnackbarContext: ProviderContext | null = null;

export function setGlobalSnackbarContext(context: ProviderContext | null) {
    globalSnackbarContext = context;
}

export function getGlobalSnackbarContext(): ProviderContext | null {
    return globalSnackbarContext;
}

export function enqueueSnackbarGlobal(
    message: string,
    options?: { variant?: 'default' | 'error' | 'success' | 'warning' | 'info' }
) {
    if (globalSnackbarContext) {
        return globalSnackbarContext.enqueueSnackbar(message, options);
    }
    console.warn('Snackbar context not available');
    return '';
}
